import React from "react";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";
import {datetimeColorGradient} from "../../../support/colors";

const headers = [
    {"label": "Cislo", "caption": "Číslo", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Produkty", "caption": "Produkty", 'filter': 'string'},
    {"label": "Pristroje", "caption": "S/N", 'filter': 'string'},
    {"label": "Nadpis", "caption": "Názov Prípadu", 'filter': 'string'},
    {"label": "Zakaznik", "caption": "Zákazník", 'filter': 'string'},
    {"label": "Stav__Stav", "caption": "Stav", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Papiere", "caption": "Papiere", 'filter': 'bool', 'narrow': true},
    {"label": "Zmena_Stavu", "caption": "Zmena Stavu", 'filter': 'dateRange'},
]

function ServiceCases(props) {
    const initialFilters = [
        {
            'label': 'Cislo',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zakaznik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nadpis',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Stav__Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Papiere',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Initial',
        },
        {
            'label': 'Pristroje',
            'lookup': '_SNR',
            'value': '',
        },
        {
            'label': 'Produkty',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Fulltext',
            'lookup': '',
            'value': '',
        },
    ]
    const baseUrl = '/service_case/service_cases'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)
    const [filteredData, setFilteredData] = React.useState([])

    function parse_links(data) {
        return data.map(entry => ({
            'Cislo': `/service_cases/service_case/${entry.id}`
        }))
    }

    function updatePapers() {
        // Update papers for each service case
        if (!data) {
            return
        }
        data.forEach((entry, index) => {
            if (!entry.Papiere) {
                entry.Papiere = "❌"
            }
            else {
                entry.Papiere = "✅"
            }
        })
    }

    function filterDuplicateInstruments() {
        // Due to multiversion CPs same instrument can appear multiple times in the same service case.
        // This function filters out duplicates.
        if (!data) {
            return
        }
        data.forEach((entry, index) => {
            if (!entry.Pristroje) {
                return
            }
            let filteredInstruments = []
            let filteredProducts = []
            entry.Pristroje.forEach((instrument, index) => {
                if (filteredInstruments.includes(instrument)) {
                    return
                }
                filteredInstruments.push(instrument)
                filteredProducts.push(entry.Produkty[index])
            })
            data[index].Pristroje = filteredInstruments
            data[index].Produkty = filteredProducts
        })
        setFilteredData(data)
    }

    function colorize() {
        // #TBD: Change from imperative to declarative
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0, 2) // Do not color table header
        new_rows.forEach((row, index) => {
            const stav = data[index].Stav
            const lastChange = data[index].Zmena_Stavu
            const stateCell = row.getElementsByTagName("td")[5]
            const stateChangeCell = row.getElementsByTagName("td")[7]
            if (stav !== null) {
                const colorState = stav["Farba"]
                stateCell.style.backgroundColor = colorState
            } else {
                stateCell.style.backgroundColor = "unset"
            }
            if (lastChange !== null && !stav["Uzavrety"]) {
                const colorChange = datetimeColorGradient(lastChange)
                stateChangeCell.style.backgroundColor = colorChange
            } else {
                stateChangeCell.style.backgroundColor = "unset"
            }
        })
    }

    React.useEffect(() => {
        updatePapers()
        filterDuplicateInstruments()
        colorize()
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ListViewCommon baseUrlFrontend={`/service_cases/service_case`}
                        noColorRows={true}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        deleteConfirmation={true}
                        deleteConfirmationText={"Naozaj chcete prípad odstrániť?"}
                        label={"Servisné prípady"}
                        fullTextSearch={true}
        />
    )
}

export default ServiceCases
